import type { RouteMode } from "../../router";
import { isPlatformGamePath } from "../../shared/routing/game-path-mode";
import type { GameApiMode } from "../../shared/services/game-api";

function currentPathname(): string {
  return typeof window === "undefined" ? "" : window.location.pathname;
}

export function isYinshV2Path(pathname = currentPathname()): boolean {
  return isPlatformGamePath("yinsh", pathname);
}

export function resolveYinshRouteMode(pathname = currentPathname()): RouteMode {
  return isYinshV2Path(pathname) ? "v2" : "legacy";
}

export function resolveYinshGameApiMode(
  pathname = currentPathname(),
): GameApiMode {
  return isYinshV2Path(pathname) ? "game-platform" : "legacy";
}
